import { Controller } from '@hotwired/stimulus';

// Sets the hidden destroy field to true when adjustment is emptied
export default class extends Controller {
  static targets = ['adjustments', 'adjustment', 'description', 'destroy'];

  static values = {
    formId: String,
  };

  connect() {
    this.boundEmptiedHandler = this.emptiedValueHandler.bind(this);
    this.boundKeyDownHandler = this.keyDownHandler.bind(this);
    Array.prototype.forEach.call(this.adjustmentTargets, (el) => {
      el.addEventListener('change', this.boundEmptiedHandler);
      el.addEventListener('keydown', this.boundKeyDownHandler);
    });
  }

  disconnect() {
    Array.prototype.forEach.call(this.adjustmentTargets, (el) => {
      el.removeEventListener('change', this.boundEmptiedHandler);
      el.removeEventListener('keydown', this.boundKeyPressHandler);
    });
  }

  emptiedValueHandler(event) {
    const adjustmentInput = event.currentTarget;
    const adjustmentIndex = this.adjustmentTargets.findIndex((t) =>
      t.contains(adjustmentInput)
    );

    if (adjustmentInput.value !== '') {
      this.destroyTargets[adjustmentIndex].setAttribute('value', false);
      return;
    }

    this.destroyTargets[adjustmentIndex].setAttribute('value', true);
  }

  keyDownHandler(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission
      // Allow emptiedValueHandler to fire
      const adjustmentInput = event.currentTarget;
      if (adjustmentInput.value.trim() === '') {
        return;
      }

      // Check if the last adjustment row has empty values
      const lastAdjustmentRow = this.adjustmentsTarget.lastElementChild;
      const rowIndex = Array.from(this.adjustmentsTarget.children).indexOf(
        lastAdjustmentRow
      );
      const lastDescriptionValue =
        this.descriptionTargets[rowIndex].value.trim();
      const lastAmountValue = this.adjustmentTargets[rowIndex].value.trim();

      if (lastDescriptionValue === '' && lastAmountValue === '') {
        return; // Skip adding a new row if the last row has empty values
      }

      this.addNewAdjustmentRow();
    }
  }

  addNewAdjustmentRow() {
    const newRow = document.createElement('tr');

    newRow.innerHTML = `
      <td><input type="text" name="order[adjustments_attributes][][description]" class="form-control" placeholder="New Adjustment" data-adjustments-target="description" form="${this.formIdValue}"></td>
      <td>
        <input type="hidden" name="order[adjustments_attributes][][id]" value="" form="${this.formIdValue}">
        <input type="hidden" name="order[adjustments_attributes][][_destroy]" value="false" data-adjustments-target="destroy" form="${this.formIdValue}">
        <input type="text" name="order[adjustments_attributes][][amount]" class="form-control text-end" placeholder="0.00" data-adjustments-target="adjustment" form="${this.formIdValue}">
      </td>
    `;
    this.adjustmentsTarget.appendChild(newRow);

    // Rebind event and keydown handlers to the new adjustment fields
    const newAdjustmentFields = newRow.querySelector(
      '[data-adjustments-target="adjustment"]'
    );
    newAdjustmentFields.addEventListener('change', this.boundEmptiedHandler);
    newAdjustmentFields.addEventListener('keydown', this.boundKeyDownHandler);

    // Move focus to the new description field
    const descriptionField = newRow.querySelector(
      '[data-adjustments-target="description"]'
    );
    if (descriptionField) {
      descriptionField.focus();
    }
  }
}
